// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Cy8zAiFUtIIzF8GT7AyF {
  border-radius: 2px;
  line-height: 19px;
  padding: 6px 10px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/network/components/header/top-header.module.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;AAAJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n#nti_report_summary_reanalyze {\n    border-radius: 2px;\n    line-height: 19px;\n    padding: 6px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nti_report_summary_reanalyze": `Cy8zAiFUtIIzF8GT7AyF`
};
export default ___CSS_LOADER_EXPORT___;
